import * as yup from "yup";

export const schema = yup.object().shape({
  sort_by: yup.string().nullable().strict(),
  price_from: yup
    .number()
    .typeError("Должно быть числом")
    .min(1000, "Минимальное значение 1000")
    .max(1299999, "Максимальное значение 1299999")
    .nullable()
    .strict(),
  price_to: yup
    .number()
    .typeError("Должно быть числом")
    .min(1000, "Минимальное значение 1000")
    .max(1299999, "Максимальное значение 1299999")
    .nullable()
    .strict()
    .test(
      "is-greater",
      'Цена "до" должна быть больше цены "от"',
      function (value) {
        const { price_from } = this.parent;
        if (price_from && value) {
          return value > price_from;
        }
        return true;
      }
    ),
  days_from: yup
    .number()
    .typeError("Должно быть числом")
    .min(1, "Минимальное значение 1")
    .max(90, "Максимальное значение 90")
    .nullable()
    .strict(),
  days_to: yup
    .number()
    .typeError("Должно быть числом")
    .min(1, "Минимальное значение 1")
    .max(90, "Максимальное значение 90")
    .nullable()
    .strict()
    .test(
      "is-greater",
      'Срок "до" должен быть больше срока "от"',
      function (value) {
        const { days_from } = this.parent;
        if (days_from && value) {
          return value > days_from;
        }
        return true;
      }
    ),
  freelancer_online: yup.boolean().strict(),
  complete_in_one_day: yup.boolean().strict(),
  only_no_view: yup.boolean().strict(),
  // city_ids: yup.number().nullable().strict(),
  // country_id: yup.number().nullable().strict(),
});
